import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, CircularProgress, Typography, Chip, Grid, Box
} from "@mui/material";
import { useSelector } from "react-redux";
import {getStudentDetails} from "../../services/adminStudents"; // Adjust the import path as necessary

const renderArray = (arr) =>
  arr && arr.length ? arr.map((item, idx) => <Chip key={idx} label={item} sx={{ mr: 0.5, mb: 0.5 }} />) : "N/A";

const renderMap = (mapObj) =>
  mapObj && Object.keys(mapObj).length
    ? Object.entries(mapObj).map(([key, value]) => (
        <Box key={key} mb={0.5}>
          <b>{key}:</b> <a href={value} target="_blank" rel="noopener noreferrer">{value}</a>
        </Box>
      ))
    : "N/A";

const renderSection = (label, value) => (
  <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
    <Grid item xs={4} sm={3} md={2}>
      <Typography variant="subtitle2">{label}</Typography>
    </Grid>
    <Grid item xs={8} sm={9} md={10}>
      <Typography variant="body2">{value}</Typography>
    </Grid>
  </Grid>
);

const StudentInfo = ({ visible, onClose, studentId }) => {
  const [loading, setLoading] = useState(false);
  const [student, setStudent] = useState(null);
  const admin = useSelector((state) => state.admin);

  useEffect(() => {
    if (visible && studentId) {
      loadData();
    }
    // eslint-disable-next-line
  }, [visible, studentId]);

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await getStudentDetails(studentId, admin.token);
      if (response.status !== 200) {
        // showToastAlert(response.data.msg, "error");
        setLoading(false);
        return;
      }
      setLoading(false);
      setStudent(response.data.student);
    } catch (error) {
      setLoading(false);
      // showToastAlert("Failed to load student details", "error");
    }
  };

  return (
    <Dialog open={visible} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Student Details</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
            <CircularProgress />
          </Box>
        ) : student ? (
          <Box>
            {renderSection("Name", student.name)}
            {renderSection("Email", student.email)}
            {renderSection("Phone", student.phone)}
            {renderSection("Department", student.department)}
            {renderSection("Year", student.year)}
            {renderSection("CGPA", student.cgpa)}
            {renderSection("Skills", renderArray(student.skills))}
            {renderSection("Location", student.location || "N/A")}
            {renderSection("Preferences", renderArray(student.preferences))}
            {renderSection("Gender", student.gender || "N/A")}
            {renderSection("Profession", student.profession || "N/A")}
            {renderSection("Work Mode", student.workMode || "N/A")}
            {renderSection("Languages", renderArray(student.languages))}
            {renderSection("Samples", renderMap(student.samples))}
            {renderSection("Email Verified", student.verifyStatus?.email ? "Yes" : "No")}
            {renderSection("Mobile Verified", student.verifyStatus?.mobile ? "Yes" : "No")}
            {renderSection("Signup with Google", student.signG ? "Yes" : "No")}
            {renderSection("Experience",
              student.experience && student.experience.length
                ? student.experience.map((exp, idx) => (
                    <Box key={idx} mb={0.5}>
                      <b>{exp.title || exp.role}</b> at {exp.company || exp.organization} ({exp.duration || ""})
                    </Box>
                  ))
                : "N/A"
            )}
            {renderSection("Education",
              student.education && student.education.length
                ? student.education.map((edu, idx) => (
                    <Box key={idx} mb={0.5}>
                      <b>{edu.degree}</b> at {edu.institute} ({edu.year || ""})
                    </Box>
                  ))
                : "N/A"
            )}
            {renderSection("Training",
              student.training && student.training.length
                ? student.training.map((tr, idx) => (
                    <Box key={idx} mb={0.5}>
                      <b>{tr.title}</b> ({tr.year || ""})
                    </Box>
                  ))
                : "N/A"
            )}
            {renderSection("Projects",
              student.projects && student.projects.length
                ? student.projects.map((proj, idx) => (
                    <Box key={idx} mb={0.5}>
                      <b>{proj.name}</b>: {proj.description}
                    </Box>
                  ))
                : "N/A"
            )}
            {renderSection("Additionals",
              student.additionals && student.additionals.length
                ? student.additionals.map((add, idx) => (
                    <Box key={idx} mb={0.5}>{add.info || JSON.stringify(add)}</Box>
                  ))
                : "N/A"
            )}
          </Box>
        ) : (
          <Typography>No student data found.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default StudentInfo;